// top-bar-content
export const navLinks = [
    { name: "Home", path: "/" },
    { name: "Data Collection", path: "/data-collection" },
    { name: "Practice Management", path: "/practice" },
    // { name: "Features", path: "/features" },
    { name: "Blog", path:  "http://blog.therapylake.com/", target:'_blank' },
    { name: "About Us", path:  "/about-us"},
    // { name: "Sign In", path: "/login" },

    // { name: 'Home', path: '/' },
    // { name: "Data Collection", path: "/data-collection" },
    // { name: 'Practice Management', path: '/practiceManagement' },
    // { name: 'Resources', path: '/recources' },
    // { name: 'About', path: '/about-us' },
];
